module.exports = __webpack_public_path__ + "bedf9c64b2918a0ff1f267f86e9d8f96.pdf";